import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-800 text-background-100">
      <div className="mx-auto grid grid-cols-1 gap-8 px-4 py-12 md:px-6 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-film-line text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              伦理片在线观看
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100">
            专注于伦理类影视作品的信息聚合与在线观看平台，涵盖伦理电影、电视剧及短片，致力于为用户提供高品质、便捷、沉浸的观影体验。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-700 text-primary-100">
              <i className="ri-wechat-line"></i>
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-700 text-primary-100">
              <i className="ri-weibo-line"></i>
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-700 text-primary-100">
              <i className="ri-mail-line"></i>
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <Link to="/category/movie" className="transition-colors hover:text-accent-300">
              影视分类
            </Link>
          </h4>
          <ul className="mt-4 space-y-2.5 text-sm text-primary-100">
            <li>
              <Link to="/category/movie" className="transition-colors hover:text-background-50">
                伦理电影
              </Link>
            </li>
            <li>
              <Link to="/category/tv" className="transition-colors hover:text-background-50">
                伦理电视剧
              </Link>
            </li>
            <li>
              <Link to="/category/short" className="transition-colors hover:text-background-50">
                伦理短片
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">关于平台</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-primary-100">
            <li>
              <Link to="/about" className="transition-colors hover:text-background-50">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/contact" className="transition-colors hover:text-background-50">
                联系我们
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition-colors hover:text-background-50">
                搜索影片
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-700">
        <div className="mx-auto flex flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-primary-200 sm:flex-row md:px-6">
          <p>© 2026 伦理片在线观看 · 本站内容仅供影视资料展示与学习交流使用。</p>
          <p>All rights reserved · 本站不提供任何影音存储与下载服务</p>
        </div>
      </div>
    </footer>
  );
}